/* ============================================================
   Re-Coco — Gallery JS
   Handles: lightbox
   ============================================================ */

(function () {
  'use strict';

  const lightbox      = document.getElementById('lightbox');
  const lightboxTitle = document.getElementById('lightbox-title');
  const lightboxImg   = document.getElementById('lightbox-img');

  document.querySelectorAll('[data-gallery-item]').forEach(item => {
    item.addEventListener('click', () => {
      if (!lightbox) return;
      
      const title = item.dataset.galleryTitle || '';
      const imgSrc = item.dataset.galleryImg;

      if (lightboxTitle) lightboxTitle.textContent = title;

      if (lightboxImg && imgSrc) {
        lightboxImg.src = imgSrc;
        lightboxImg.classList.remove('hidden');
        
        // Hide placeholder if it exists
        const placeholder = document.getElementById('lightbox-placeholder');
        if (placeholder) placeholder.style.display = 'none';
      } else {
        if (lightboxImg) lightboxImg.classList.add('hidden');
        const placeholder = document.getElementById('lightbox-placeholder');
        if (placeholder) placeholder.style.display = 'block';
      }

      lightbox.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
    });
  });

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.add('hidden');
    document.body.style.overflow = '';
    if (lightboxImg) lightboxImg.src = '';
  }

  const closeBtn = document.getElementById('lightbox-close');
  if (closeBtn) closeBtn.addEventListener('click', closeLightbox);

  if (lightbox) {
    lightbox.addEventListener('click', e => {
      if (e.target === lightbox || e.target.closest('.w-full.h-full') === e.target) {
         closeLightbox();
      }
    });
  }

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeLightbox();
  });

})();
